

































import Vue from 'vue';
import Component from 'vue-class-component';
import FileManagement from '../../shared/shared/components/FileManagement.vue';

@Component({
    components: {
        FileManagement,
    },
})
export default class UploadInvoice extends Vue {}
